"use client";

import { useRouter } from "next/navigation";

import { LoginForm } from "@saas/account/feature/login-form/login-form";

import { config } from "@sales/config/config";

interface ILoginClientPageProps {
  redirectTo?: string;
}

export const LoginClientPage = ({ redirectTo }: ILoginClientPageProps) => {
  const router = useRouter();

  const handleLoginSuccess = () => {
    const redirectUrl = redirectTo ?? config.HOME_PATH;

    router.push(redirectUrl);
  };

  return <LoginForm onSuccess={handleLoginSuccess} />;
};
